import React from "react";
import "./loanTips.css";
// FaRupeeSign को FaDollarSign के साथ इंपोर्ट किया गया
import { FaChartLine, FaShieldAlt, FaCalendarCheck, FaUniversity, FaHandshake, FaUserCheck, FaClock, FaRupeeSign } from "react-icons/fa";
import { Link } from "react-router-dom"; 

const tipsData = [
  {
    icon: <FaChartLine />,
    title: "Monitor Your Credit Score",
    description: "A good score (750+) ensures lower interest rates. Check it regularly and correct any errors.",
    color: "#00ff7f", // Neon Green
  },
  {
    icon: <FaCalendarCheck />,
    title: "Plan Repayment Early",
    description: "Always know your EMI dates and schedule automatic payments to avoid late fees and penalties.",
    color: "#d50ac6", // Magenta
  },
  {
    icon: <FaShieldAlt />,
    title: "Read the Fine Print",
    description: "Thoroughly understand the terms, conditions, processing fees, and foreclosure charges before signing.",
    color: "#ecd969", // Gold/Yellowish
  },
  {
    icon: <FaUniversity />,
    title: "Compare Multiple Lenders",
    description: "Don't settle for the first offer. Compare interest rates and fees from different banks and platforms.",
    color: "#00ffd5", // Aqua Green
  },
  {
    icon: <FaHandshake />,
    title: "Borrow Only What You Need",
    description: "Taking a bigger loan than necessary increases your debt burden and overall interest cost.",
    color: "#ff66e6", // Pink
  },
  {
    icon: <FaChartLine />,
    title: "Keep Documentation Handy",
    description: "Ensure all required documents are clear, current, and organized for a faster approval process.",
    color: "#00ff7f", 
  },
];

// New Data for Statistics
const statsData = [
    { value: "98%", label: "Approval Rate", icon: <FaUserCheck />, color: "#00ff7f" },
    { value: "5 Min", label: "Disbursal Time", icon: <FaClock />, color: "#d50ac6" },
    // UPDATED ICON & VALUE
    { value: "₹2 Cr+", label: "Total Loans", icon: <FaRupeeSign />, color: "#ecd969" },
];

const LoanTips = () => {
  return (
    <section className="lt-wrap">
      <div className="lt-container">
        {/* LEFT SIDE: Title, Extended Intro Text, and Key Stats Box */}
        <div className="lt-left">
          <div className="lt-eyebrow">Financial Wisdom</div>
          <h2 className="lt-title">
            Smart Loan <span className="lt-highlight">Tips for Success</span>
          </h2>
          <p className="lt-sub">
            A successful loan journey starts with smart decisions. Follow these expert tips to manage your debt responsibly and save money.
          </p>
          
          {/* Extended Text */}
          <p className="lt-extended-text">
            Understanding the nuances of your loan agreement, from the Annual Percentage Rate (APR) to the tenure flexibility, is crucial. Our goal is to empower you with the right knowledge before you commit, ensuring long-term financial stability.
          </p>

          {/* New: Key Statistics Box */}
          <div className="lt-stats-box">
            <h4 className="lt-stats-heading">Our Key Figures</h4>
            <div className="lt-stats-grid">
                {statsData.map((stat, index) => (
                    <div 
                        key={index} 
                        className="lt-stat-item"
                        style={{ '--stat-color': stat.color }}
                    >
                        <div className="lt-stat-icon">{stat.icon}</div>
                        <p className="lt-stat-value">{stat.value}</p>
                        <p className="lt-stat-label">{stat.label}</p>
                    </div>
                ))}
            </div>
          </div>
          
        </div>

        {/* RIGHT SIDE: Scrollable Tips Feed */}
        <div className="lt-right">
          <div className="lt-tips-feed">
            {tipsData.map((tip, index) => (
              <div 
                key={index} 
                className="lt-tip-item"
                style={{ 
                  '--tip-color': tip.color,
                  '--tip-delay': `${index * 0.15}s` 
                }}
              >
                <div className="lt-tip-icon-box">
                  {tip.icon}
                </div>
                <div className="lt-tip-content">
                  <h3 className="lt-tip-title">{tip.title}</h3>
                  <p className="lt-tip-desc">{tip.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoanTips;